// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_base-highlight_wrapper_1Oat7"};